import { IconProps } from "@design-system/types";

export function ColoredArabicLogoIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="304"
      height="57"
      viewBox="0 0 1603 294"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_449_8405"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="1603"
        height="294"
      >
        <path d="M1602.53 0H0V293.38H1602.53V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_449_8405)">
        <path
          d="M1263.82 120.8C1255.87 113.51 1251.34 103.3 1251.34 91.99C1251.34 70.3 1268.99 52.65 1290.68 52.65H1359.13L1359.96 52.07L1432.78 0H1290.68C1239.95 0 1198.69 41.27 1198.69 91.99C1198.69 114.34 1206.71 135.32 1220.67 151.66L1263.83 120.8H1263.82Z"
          fill="#0028ED"
        />
        <path
          d="M1523.91 0C1501.46 0 1479.55 6.95 1461.2 19.89L1412.58 54.18L1246.72 172.76C1247.26 173.05 1247.78 173.38 1248.33 173.67C1261.72 180.61 1276.25 184.05 1290.72 184.05C1309.32 184.05 1327.83 178.37 1343.69 167.19L1580.94 0H1523.91Z"
          fill="#0028ED"
        />
        <path
          d="M1537.39 172.58C1545.34 179.87 1549.88 190.08 1549.88 201.39C1549.88 223.08 1532.23 240.73 1510.54 240.73H1442.09L1441.25 241.31L1368.43 293.38H1510.54C1561.26 293.38 1602.53 252.11 1602.53 201.39C1602.53 179.04 1594.5 158.06 1580.55 141.72L1537.39 172.58Z"
          fill="#0028ED"
        />
        <path
          d="M1277.3 293.38C1299.76 293.38 1321.66 286.43 1340.01 273.49L1388.64 239.2L1554.49 120.62C1553.95 120.33 1553.43 120 1552.88 119.71C1539.48 112.77 1524.96 109.33 1510.49 109.33C1491.88 109.33 1473.38 115.01 1457.52 126.19L1220.26 293.37H1277.29L1277.3 293.38Z"
          fill="#0028ED"
        />
        <path
          d="M1007.87 128.8L1025.01 116.74C1024.82 116.87 1024.62 116.99 1024.43 117.12L1007.87 128.8Z"
          fill="#0028ED"
        />
        <path d="M746.51 98.83H706.32V243.03H746.51V98.83Z" fill="#0028ED" />
        <path d="M676.86 25.73H636.67V243.03H676.86V25.73Z" fill="#0028ED" />
        <path
          d="M310.3 202.84H41.38L0 243.03H310.3H318.79H350.49V99.96H310.3V202.84Z"
          fill="#0028ED"
        />
        <path
          d="M726.426 18.0196L697.208 47.2372L726.426 76.4549L755.644 47.2372L726.426 18.0196Z"
          fill="#0028ED"
        />
        <path
          d="M241.681 80.0855L212.463 109.303L241.681 138.521L270.898 109.303L241.681 80.0855Z"
          fill="#0028ED"
        />
        <path
          d="M212.46 109.3L183.24 80.08L154.03 109.3L183.24 138.51L212.46 109.3Z"
          fill="#0028ED"
        />
        <path
          d="M493.91 166.11C493.91 145.86 510.38 129.39 530.63 129.39C541.26 129.39 551.36 133.99 558.35 142.02L588.67 115.63C574.04 98.83 552.89 89.2 530.63 89.2C488.22 89.2 453.72 123.7 453.72 166.11C453.72 179.4 457.11 191.91 463.07 202.83H420.13V25.73H379.94V243.03H607.22V202.84H530.63C510.38 202.84 493.91 186.37 493.91 166.12"
          fill="#0028ED"
        />
        <path
          d="M1108.22 89.17L1073.25 113.77C1073.25 113.77 1073.3 113.79 1073.31 113.8C1089.25 122.07 1098.77 137.72 1098.77 155.67C1098.77 181.68 1077.61 202.83 1051.6 202.83H946.83L889.83 243.02H1051.6C1099.77 243.02 1138.95 203.83 1138.95 155.66C1138.95 129.62 1127.5 105.53 1108.21 89.16"
          fill="#0028ED"
        />
        <path
          d="M1024.43 117.13C1024.62 116.99 1024.82 116.88 1025.02 116.75L1084.6 74.83C1057.13 63.58 1025.86 66.94 1001.27 84.29L849.82 191.08L809.63 219.3L775.96 243.04H811.05C833.47 243.04 855.33 236.12 873.66 223.22L1007.87 128.81L1024.42 117.13H1024.43Z"
          fill="#0028ED"
        />
        <path
          d="M816.15 98.83H775.96V212.11L816.15 183.77V98.83Z"
          fill="#0028ED"
        />
      </g>
    </svg>
  );
}
